export default "__VITE_ASSET__vYHjZHB8__"